/* eslint-disable react/prop-types, no-undef */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const useGoogleAnalytics = () => {
  const browserLocation = useLocation();
  const user = useSelector((state) => state.app.user);
  const brand = useSelector((state) => state.app.brand);

  useEffect(() => {
    if (!gtag) {
      return;
    }

    if (!user?.bridg_user_id) {
      // user id not yet available or logged out
      gtag('set', 'user_id', null);
      gtag('set', 'user_properties', null);
      return;
    }

    const userProps = {
      // these are persistent via cookies, it seems we need to explicitly set
      // as null to remove them
      user_email_domain: user.email?.split('@', 2)?.[1] || null,
      brand_client_type: brand.client_type || null,
      brand_sid: brand.sid || null,
    };

    gtag('set', 'user_id', user.bridg_user_id);
    gtag('set', 'user_properties', userProps);
  }, [user, brand]);

  useEffect(() => {
    if (!gtag) {
      return;
    }

    // debug
    // gtag('get', config.google_analytics_tag, 'user_properties', (field) => console.log(`<<${ JSON.stringify(field)}`));
    gtag('event', 'page_view', { page_location: browserLocation.pathname });
  }, [browserLocation]);
};

export default useGoogleAnalytics;
